import { render, staticRenderFns } from "./configLog.vue?vue&type=template&id=2777ab8e"
import script from "./configLog.vue?vue&type=script&lang=ts"
export * from "./configLog.vue?vue&type=script&lang=ts"
import style0 from "./configLog.vue?vue&type=style&index=0&id=2777ab8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports